<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <b-row class="text-center">
                <b-col>
                    Rides por:
                    <select v-model="by" @change="fetchDataChart">
                        <option value="checkinStatus">Checkin Status</option>
                        <option value="status">Status</option>
                    </select>
                    <b-button variant="outline-primary"  @click="fetchDataChart" size="sm" class="ml-2" :disabled="loading" >
                        <md-icon icon="search"/>
                    </b-button>
                    <span class="ml-3">
                        <label class="mr-2">Vista:</label>
                        <b-form-radio-group
                            v-model="unifiedView"
                            :options="viewOptions"
                            @change="fetchDataChart"
                            buttons
                            button-variant="outline-secondary"
                            size="sm"
                            :disabled="loading"
                        ></b-form-radio-group>
                        <small class="text-muted ml-2" v-if="unifiedView">
                            (Active + Done + NoShow juntos)
                        </small>
                    </span>
                </b-col>
            </b-row>
            <chart :options="chartOptions"  ref="chart"></chart>
            <span>Total de rides:{{totalRides}}</span>
        </b-overlay>

    </section>

</template>

<script>
    import {Chart} from 'highcharts-vue'
    import api from '../../../../../api.js'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "RidePerStatus",
        components:{Chart},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];
            return {
                totalRides:0,
                originalCategories:[],
                originalSeries:[],
                loading:false,
                unifiedView: false,
                viewOptions: [
                    { text: 'Separar status', value: false },
                    { text: 'Unir status', value: true }
                ],
                exporting: {
                    enabled: true
                },
                codeReport : "rides-per-status",
                chartOptions:{
                    title: {
                        text: ''
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Numero de rides'
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:''
                    },
                    xAxis:{
                        type: 'category',
                        categories:[],
                        max:null,
                    },
                    series: seriesExample,
					plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            },
                        }
                    }
                },
                by:"status"
            }
        },
        methods:{
            fetchDataChart(){
                this.loading=true;
                let localFilters = {...this.filters,...{by: this.by, unifiedView: this.unifiedView}}
                api(this).get(`/dashboard/operations/charts/${this.codeReport}`,{params: {filters:localFilters}}).then((res) => {
                    this.totalRides = res.data.totalRides;
                    this.originalCategories = res.data.categories;
                    this.originalSeries     = res.data.series;
                    this.chartOptions.series               = res.data.series;
                    this.chartOptions.xAxis.categories     = res.data.categories;
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.loading=false;
                    this.$emit('finished');
                })
            }
        },
        watch:{
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        }
    }
</script>

<style scoped>

</style>
